export class ImageMetadataProperty {
  value: string | number | null;
  description: string | null;

  constructor(value: string | number | null = "NA", description: string | null = "NA") {
    this.value = value;
    this.description = description;
  }
}
